import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'atx-amp-timeline-marker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './timeline-marker.component.html',
  styleUrls: ['./timeline-marker.component.scss'],
  standalone: false,
})
export class TimelineMarkerComponent {
  @Input()
  public start: number;

  @Input()
  public end: number;

  @Input()
  public previewUrl: string[];

  @Input()
  public isAvailable: boolean;

  @Input()
  public videoDuration: number;

  @Output()
  public markerClick: EventEmitter<number> = new EventEmitter();

  @HostBinding('style.left.%')
  public get leftAlignment() {
    return (this.start / this.videoDuration) * 100;
  }

  @HostBinding('style.width')
  public get width() {
    const end = (this.end / this.videoDuration) * 100;
    const start = (this.start / this.videoDuration) * 100;

    return `calc(${(end ?? 100) + '%'} - ${start + '%'})`;
  }

  public addResize(url: string) {
    const paramChar = url.includes('?') ? '&' : '?';

    return `${url}${paramChar}maxWidth=100&mode=max&scale=both`;
  }
}
